import { Injectable } from "@angular/core";

/**
 * Records the URL the browser loaded the document at, so a feature can tell
 * whether *it* was the target of a hard refresh / direct entry / bookmark (the
 * captured URL points at it) versus a later in-app SPA navigation (it does not).
 *
 * `capture()` must be called once at the very start of `main.ts` — before
 * `bootstrapApplication` and before the router runs any navigation — so the URL
 * reflects the real page load rather than wherever the app has since navigated.
 */
@Injectable({ providedIn: "root" })
export class InitialNavigationService {
	private static capturedUrl: string | null = null;
	private static consumed = false;

	/** Snapshot the loaded document URL. Called once from `main.ts` at startup. */
	static capture(): void {
		InitialNavigationService.capturedUrl = `${window.location.pathname}${window.location.search}`;
	}

	/**
	 * Returns the captured document URL the first time it is called, then null for
	 * the remainder of this page load. The first feature to ask "was the document
	 * loaded at me?" consumes the token; subsequent entries are in-app navigations.
	 */
	consumeInitialUrl(): string | null {
		if (InitialNavigationService.consumed) { return null; }
		InitialNavigationService.consumed = true;
		return InitialNavigationService.capturedUrl;
	}
}
